import { getValidAccessToken } from './getValidAccessToken';

const REFERRAL_CODE_REGEX = /^[A-Z0-9]{4,32}$/;

const parseJsonSafely = async (response) => {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};

export const claimOAuthReferralBonus = async ({ referralCode } = {}) => {
  const normalizedCode = String(referralCode || '').trim().toUpperCase();
  if (!REFERRAL_CODE_REGEX.test(normalizedCode)) {
    return { processed: false, reason: 'invalid_referral_code' };
  }

  const accessToken = await getValidAccessToken();
  if (!accessToken) {
    const err = new Error('Not authenticated');
    err.code = 'UNAUTHORIZED';
    throw err;
  }

  const response = await fetch('/api/claimOAuthReferral', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ referralCode: normalizedCode }),
  });

  const data = await parseJsonSafely(response);
  if (!response.ok) {
    const err = new Error(data?.error || 'Failed to claim OAuth referral');
    err.status = response.status;
    err.code = data?.code || 'UNKNOWN';
    throw err;
  }

  return data || { processed: false };
};
